import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {ONGOING_OBLIGATIONS_OF_POSITION_2} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const OngoingObligationsOfPositions2 = "tfOngoingObligationsOfPositions2Question";

export function ongoingObligationsOfPositions2() {
    return {
        templateUrl: "app/quiz/fxe/questions/OngoingObligationsOfPositions2.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: OngoingObligationsOfPositions2Controller
    };
}

export class OngoingObligationsOfPositions2Controller extends FxeQuizQuestionController {
    public config = ONGOING_OBLIGATIONS_OF_POSITION_2;
}
